{
  "dashboard": {
    "navigation_title": "Dashboards",
    "title": "Dashboard",
    "report_title_placeholder": "<enter report name>",
    "no_widgets": "No widgets are created yet!",
    "add_widget": "Add Widget",
    "access_denied": "Sorry. You don't have access to the dashboard.",
    "default_title": "Dashboard",
    "max_number_of_widgets_reached": "Sorry... Can't add more than %{widget_number} widgets!",
    "chart_no_data": "No data to display",
    "chart_no_parameters_selected": "Please select parameter",
    "nodes_no_data": "No data to display",
    "thiamis_online": "Thiamis Online",
    "devices_online": "Devices Online (24H)",
    "total_devices": "Devices Total",
    "users_online": "Users Online",
    "active_alerts": "Alerts Active",
    "widget_removed": "Due to access loss widget has been removed",
    "time": {
      "30_min": "Past 30 Minutes",
      "1_hour": "Past 1 Hour",
      "1_day": "Past 1 Day",
      "hours": "Past %{hours} Hours",
      "days": "Past %{hours} Days",
      "last_day": "Past Day",
      "yesterday": "Yersterday",
      "last_week": "Past Week"
    }
  }
}
